export default __webpack_public_path__ + "maps-examples-runtime-toggle-layer-thumbnail-480-3cde922f65ac01da25952a1f84e57789.png";